<div class="preloader" id="loader" style="
        background-image: url('assets/img/preloader.gif');
        position: fixed;
        display: none;
        left: 0px;
        top: 0px;
        width: 100%;
        height: 100%;
        z-index: 999999;
        background-color: rgb(255, 255, 255);
        background-position: center center;
        background-repeat: no-repeat;
        overflow: hidden;
    ">
</div>

<main class="main" style="font-size: large; font-weight: 500">
  <div class="container-fluid bg-white pt-3 pb-5">
    <form [formGroup]="productForm" (ngSubmit)="Submit()">
      <div class="container app-header-custom mb-3">
        <div class="row g-2">
          <div class="col-12 col-sm-6 col-md-2 mb-2">
            <p class="m-0 p-2">
              <span class="fontcolor_red">Claim ID:</span>
              {{ EditForm?.inspection_id }}
            </p>
          </div>
          <div class="col-12 col-sm-6 col-md-2 mb-2">
            <p class="m-0 p-2">
              <span class="fontcolor_red">Insured:</span>
              {{ EditForm?.insured_name }}
            </p>
          </div>
          <div class="col-12 col-sm-6 col-md-2 mb-2">
            <p class="m-0 p-2">
              <span class="fontcolor_red">Regn No.</span>
              {{ EditForm?.vehicle_reg_no }}
            </p>
          </div>
          <div class="col-12 col-md-6"></div>
        </div>
      </div>

      <!-- Vehicle Images Section -->
      <div cdkDropList class="example-list" (cdkDropListDropped)="drop($event)" formArrayName="form_field">
        <div class="row g-3">
          <ng-container *ngFor="let item of formFieldArray().controls; let i = index">
            <div [formGroupName]="i" class="col-12 col-sm-6 col-md-4 mb-2" *ngIf="item.controls.form_field_label">
              <div class="form-group">
                <div class="input-group d-flex flex-column align-items-center">
                  <input type="file" accept="image/*" [attr.capture]="capture" class="d-none cursor-pointer"
                    (change)="fileChange($event,i,'form_field_label',item.controls.form_field_label)"
                    id="form_field_label{{ i }}" />
                  <i class="fa fa-times close cursor-pointer"
                    *ngIf="EditActive && ImageArray[i].form_field_label.custom" aria-hidden="true"
                    (click)="removeQuantity(i)">
                  </i>
                  <img class="rounded img-fluid mb-2 cursor-pointer" role="button"
                    [src]="ImageArray[i].form_field_label.src" accept="file_type | video/* | image/* | media_type"
                    alt="" style="max-width: 100%; height: auto;" />
                  <label class="text-center w-100" for="form_field_label{{ i }}">
                    {{ImageArray[i].form_field_label.name}}
                  </label>
                  <input type="hidden" formControlName="form_field_label" />
                  <span class="form-text text-danger"
                    *ngIf="(item.controls.form_field_label.touched || submitted) && item.controls.form_field_label.errors?.required">
                    *Required
                  </span>
                </div>
              </div>
            </div>
          </ng-container>
        </div>
      </div>

      <!-- Add Image Field Section -->
      <div class="container app-header-custom mt-3">
        <div class="row g-2" *ngIf="EditActive">
          <div class="col-12 col-md-3 mb-2">Vehicle Images</div>
          <div class="col-12 col-md-3 mb-2 offset-md-4">
            <input type="text" [(ngModel)]="Add_image_field" [ngModelOptions]="{ standalone: true }"
              class="form-control w-100" maxlength="40" placeholder="Enter Name for Survey Checklist" required />
          </div>
          <div class="col-12 col-md-2 mb-2">
            <button (click)="addFormField('assets/img/no-image.jpg',Add_image_field,true)" type="button"
              class="btn btn-bg w-100">
              <i style="color: #fff" class="fa fa-plus"></i> Add Image Field
            </button>
          </div>
        </div>
      </div>

      <!-- Vehicle Document Section -->
      <div class="p-3">
        <div class="row g-3 example-list" formArrayName="form_field">
          <ng-container *ngFor="let item of formFieldArray().controls; let i = index">
            <div [formGroupName]="i" class="col-12 col-sm-6 col-md-3 mb-2" *ngIf="item.controls.form_document_label">
              <div class="input-group d-flex flex-column align-items-center">
                <input type="file" accept="image/*" [attr.capture]="capture" class="d-none"
                  (change)="fileChange($event,i,'form_document_label',item.controls.form_document_label)"
                  id="form_field_label{{ i }}" />
                <i class="fa fa-times close document cursor-pointer" aria-hidden="true"
                  *ngIf="EditActive && ImageArray[i].form_document_label.custom" (click)="removeQuantity(i)"></i>
                <img class="rounded img-fluid mb-2" [src]="ImageArray[i].form_document_label.src"
                  accept="file_type | audio/* | video/* | image/* | media_type" alt=""
                  style="max-width: 100%; height: auto;" />
                <label for="form_field_label{{ i }}" class="text-center w-100">
                  {{ImageArray[i].form_document_label.name}}
                </label>
                <input type="hidden" formControlName="form_document_label" />
                <span class="form-text text-danger"
                  *ngIf="(item.controls.form_document_label.touched || submitted) && item.controls.form_document_label.errors?.required">
                  *Required
                </span>
              </div>
            </div>
          </ng-container>
        </div>
      </div>

      <!-- Add Document Field Section -->
      <div class="container app-header-custom mb-5">
        <div class="row g-2" *ngIf="EditActive">
          <div class="col-12 col-md-3 mb-2">Vehicle Document</div>
          <div class="col-12 col-md-3 mb-2 offset-md-4">
            <input type="text" [(ngModel)]="Document_field" [ngModelOptions]="{ standalone: true }"
              class="form-control w-100" maxlength="40" placeholder="Enter Name for Survey Checklist" required />
          </div>
          <div class="col-12 col-md-2 mb-2">
            <button (click)="addDocumentField('assets/img/no-image.jpg',Document_field,true)" type="button"
              class="btn btn-bg w-100">
              <i style="color: #fff" class="fa fa-plus"></i> Add Document Field
            </button>
          </div>
        </div>
      </div>

      <!-- Survey Video Section -->
      <div class="container app-header-custom" *ngIf="isVideoActive">
        <div class="row g-2">
          <div class="col-12 col-md-5">
            <label>Survey Video <p class="text-danger">(Video should not exceed more than 30 Seconds)</p></label>
            <div class="input-group p-1">
              <input formControlName="video_file" type="file" (change)="onFileChange($event)"
                class="form-control w-100 h-auto" value="VideoIsAllowed" accept="video/mp4,video/x-m4v,video/*"
                capture="camera" />
            </div>
          </div>
        </div>
      </div>

      <!-- Job Remark Section -->
      <div class="container app-header-custom mt-3">
        <div class="row my-3">
          <div class="col-12">Job Remark</div>
        </div>
      </div>
      <div class="container p-0">
        <div class="row mt-3">
          <div class="col-12">
            <quill-editor [modules]="quillConfig" formControlName="job_remark" [placeholder]="'Job Remark'">
            </quill-editor>
          </div>
        </div>
      </div>

      <!-- Submit Button -->
      <div class="container app-header-custom mt-2">
        <div class="row">
          <div class="col-12 col-md-2 mt-md-2 offset-md-10">
            <button type="submit" class="btn btn-danger w-100">
              Submit
            </button>
          </div>
        </div>
      </div>

      <!-- Modal Section -->
      <div bsModal #primaryModal="bs-modal" class="modal fade" tabindex="-1" role="dialog"
        aria-labelledby="myModalLabel" aria-hidden="true" [config]="{ backdrop: 'static', keyboard: false }">
        <div class="modal-dialog modal-xl" role="document">
          <div class="modal-content" style="border-color: white">
            <div class="modal-body">
              <div class="row">
                <div class="col-12 text-end">
                  <button type="button" class="btn-close btn bg-transparent border-0" aria-label="Close"
                    (click)="primaryModal.hide()">
                    <span class="visually-hidden">&times;</span>
                  </button>
                </div>
                <div class="col-12 mx-auto">
                  <div class="card-body">
                    <ng-container *ngIf="imageURL">
                      <app-image-editor [inputImage]="imageURL"></app-image-editor>
                    </ng-container>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</main>